

const getDromoOnboardingPropertyFields = (platformType) => {
    return [
      {
        label: "Property Name",
        key: "property_name",
        validators: [{ validate: "required" }],
      },
      {
        label: "Property Code",
        key: "property_code",
        validators: [{ validate: "required" }],
      },
      {
        label: "Brand",
        key: "brand",
        validators: [{ validate: "required" }],
      },
      {
        label: "PMS",
        key: "pms",
        validators: [{ validate: "required" }],
      },
      {
        label: "POS",
        key: "pos",
        validators: [{ validate: "required" }],
      },
      {
        label: "Time Zone",
        key: "property_time_zone",
        validators: [{ validate: "required" }],
      },
      {
        label: "Property Contact First Name",
        key: "property_contact_first_name",
        validators: [{ validate: "required" }],
      },
      {
        label: "Property Contact last Name",
        key: "property_contact_last_name",
        validators: [{ validate: "required" }],
      },
      {
        label: "Property Contact Email",
        key: "property_contact_email",
        validators: [
          { validate: "required" },
          { validate: "regex_match", regex: "^\\S+@\\S+\\.\\S+$" },
        ],
      },
    ];
  }
  
  export default getDromoOnboardingPropertyFields;
  